<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { useUmsokn } from '@/composables/Applications/UseUmsokn'

const { t } = useI18n()
const { umsokn } = useUmsokn()

const props = defineProps<{ disable?: boolean }>()

const mustBeTrue = (value: boolean) => value === true

const rules = {
  umsokn: {
    confirm: { mustBeTrue }
  }
}

const v$ = useVuelidate(rules, { umsokn })

defineExpose({
  validate() {
    v$.value.$touch()
    return !v$.value.$invalid
  }
})
</script>

<template>
  <div v-if="umsokn">
    <v-col :class="props.disable">
      <v-row>
        <v-col>
          <h2 class="forms__header">
            {{ t('lan_greidslufrest_umsokn_step6_header') }}
          </h2>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-checkbox
            v-model="umsokn.confirm"
            :disabled="props.disable"
            :label="t('lan_greidslufrest_umsokn_step6_confirm')"
            :error="v$.umsokn.confirm.$error"
            :error-messages="
              v$.umsokn.confirm.$error ? [t('umsokn_general_required_error')] : []
            "
          />
        </v-col>

        <v-col cols="12">
          <v-textarea
            v-model="umsokn.comment"
            :disabled="props.disable"
            :label="t('lan_greidslufrest_umsokn_step6_athugasemd')"
            :placeholder="t('lan_greidslufrest_umsokn_step6_athugasemd')"
            variant="outlined"
            rows="4"
            auto-grow
          />
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>

<style scoped>
.forms__header {
  font-weight: 700;
  margin-bottom: 16px;
}
</style>
